import { CreateSaleForm } from '../components/create-sale-form';
import { useSalesRoundsSuspense } from '@/features/sales-rounds/api/list-sales-round';
import { Card } from '@/shared/components/ui/card';
import { useCreateSale } from '../api/create-sale';
import { useNavigate } from 'react-router-dom';
import { paths } from '@/config/paths';
import { useQueryClient } from '@tanstack/react-query';
import { listGroupsQueryOptions } from '@/features/groups/api/list-groups';
import { createRoundOption } from '../utils/round-options';

export function CreateSale() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const mutation = useCreateSale({
    mutationConfig: {
      onSuccess: async ({ id }) => {
        await queryClient.invalidateQueries({ queryKey: listGroupsQueryOptions().queryKey });
        navigate(paths.sale.overview.getHref(id));
      },
    },
  });
  const { data: rounds } = useSalesRoundsSuspense({});

  if (rounds.length <= 0) {
    return <div>
      Inga försäljningsrundor öppna
    </div>
  }

  return (
    <div>
      <Card label="Starta försäljning">
        <CreateSaleForm
          roundOptions={rounds.map(createRoundOption)}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 md:[&>*:last-child]:col-start-2"
          onSubmit={(data) => mutation.mutateAsync({ data })}
        />
      </Card>
    </div>
  );
}
